import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
//widgets
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
//icons
import Clear from '@material-ui/icons/Clear';
import FilterList from '@material-ui/icons/FilterList';

import WrappedPerfectScrollbar from '../WrappedPerfectScrollbar/WrappedPerfectScrollbar';

function CustomSelect({ ...props }) {
  const {
    classes,
    label = '',
    name,
    menuItems,
    value = '',
    firstKey,
    multiple,
    context,
    required,
    error,
    onChange,
    ...rest
  } = props;
  const labelRef = useRef(null);
  const [filter, updateFilter] = useState('');
  const randomNumber = Math.random().toString(36).substr(2, 5);
  const isObj = typeof menuItems[0] === 'object';
  const options =
    isObj && menuItems[0].active !== undefined
      ? menuItems.filter(
          (item) =>
            item.active &&
            (filter !== ''
              ? item.name
                  .toString()
                  .toLowerCase()
                  .indexOf(filter.toLowerCase()) > -1
              : true)
        )
      : filter === ''
      ? menuItems
      : menuItems.filter((item) =>
          isObj
            ? item.name.toString().toLowerCase().indexOf(filter.toLowerCase()) >
              -1
            : item.toString().toLowerCase().indexOf(filter.toLowerCase()) > -1
        );
  if (isObj && menuItems[0].active !== undefined) {
    const activeValue = menuItems.find((item) => item.id === value);
    if (activeValue && options.findIndex((item) => item.id === value) === -1)
      options.push(activeValue);
  }
  return (
    <FormControl
      fullWidth
      placeholder={label}
      required={required}
      style={{
        minWidth: labelRef.current?.offsetWidth ?? 'fit-content',
        width:
          value.length < label.length ? `${label.length}ch` : 'fit-content',
      }}
    >
      {label ? (
        <InputLabel
          ref={labelRef}
          shrink={true}
          htmlFor={'select' + randomNumber}
          className={classes.label}
        >
          {label}
        </InputLabel>
      ) : null}
      <Select
        classes={{
          root: context ? classes[context] : undefined,
        }}
        inputProps={{
          name: name ?? 'select' + randomNumber,
          id: 'select' + randomNumber,
          className: classes.fullWidth,
          placeholder: label,
        }}
        MenuProps={{
          PaperProps: {
            component: WrappedPerfectScrollbar,
            tabIndex: 1,
            classes: { rounded: classes.menuPaper },
          },
        }}
        name={name}
        value={value}
        multiple={multiple}
        placeholder={label}
        renderValue={
          !multiple
            ? undefined
            : (selected) =>
                Array.isArray(selected)
                  ? (isObj
                      ? options.reduce(
                          (acc, item) =>
                            acc.concat(
                              selected.indexOf(item.id) !== -1 ? item.name : []
                            ),
                          []
                        )
                      : selected
                    ).join(', ')
                  : selected
        }
        className={classes.select}
        onClick={(event) => event.stopPropagation()}
        onChange={onChange}
        {...rest}
      >
        {multiple && menuItems.length > 10 ? (
          <div className={classes.selectAll}>
            <Checkbox
              color="primary"
              checked={value.length === options.length}
              onClick={(event) => {
                event.stopPropagation();
                onChange({
                  target: {
                    value:
                      value.length === options.length
                        ? []
                        : options.map((o) =>
                            typeof o === 'object' ? o.id : o
                          ),
                  },
                });
              }}
              className={classes.checkboxIcon}
              classes={{
                checked: classes.checked,
              }}
            />
            <TextField
              label="Filter"
              id={'filter' + randomNumber}
              value={filter}
              onClick={(event) => event.stopPropagation()}
              onChange={(event) => updateFilter(event.target.value)}
              InputProps={{
                endAdornment:
                  filter !== '' ? (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Clear Filter"
                        onClick={() => updateFilter('')}
                      >
                        <Clear />
                      </IconButton>
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="end">
                      <FilterList
                        color="disabled"
                        className={classes.filterIcon}
                      />
                    </InputAdornment>
                  ),
              }}
            />
          </div>
        ) : null}
        {firstKey !== undefined &&
        firstKey !== null &&
        (typeof firstKey === 'object' && firstKey.active === false
          ? value === firstKey.id
          : true) ? (
          <MenuItem
            key={0}
            value={typeof firstKey === 'object' ? firstKey.id : firstKey}
            disabled={
              value === (typeof firstKey === 'object' ? firstKey.id : firstKey)
            }
          >
            {typeof firstKey === 'object' ? firstKey.name : firstKey}
          </MenuItem>
        ) : null}
        {options.map((item, key) =>
          multiple ? (
            <MenuItem
              value={typeof item === 'object' ? item.id : item}
              key={key + 1}
            >
              <Checkbox
                color="primary"
                checked={
                  value.indexOf(typeof item === 'object' ? item.id : item) >= 0
                }
                value={
                  typeof item === 'object'
                    ? item.id.toString()
                    : item.toString()
                }
                className={classes.checkboxIcon}
                classes={{
                  checked: classes.checked,
                }}
              />
              <ListItemText
                primary={typeof item === 'object' ? item.name : item}
              />
            </MenuItem>
          ) : (
            <MenuItem
              key={key + 1}
              disabled={(typeof item === 'object' ? item.id : item) === value}
              value={typeof item === 'object' ? item.id : item}
            >
              {typeof item === 'object' ? item.name : item}
            </MenuItem>
          )
        )}
      </Select>
      {error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
}

CustomSelect.defaultProps = {
  menuItems: [],
};

CustomSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.node,
  menuItems: PropTypes.array,
  context: PropTypes.oneOf(['success', 'error', 'warn']),
};

const styles = {
  fullWidth: {
    width: '100%',
  },
  select: {
    fontSize: 'inherit',
  },
  label: {
    fontSize: 'inherit',
    whiteSpace: 'nowrap',
  },
  menuPaper: {
    height: 'auto',
  },
  checkboxIcon: {
    //color: "#027cb5",
    width: '32px',
    height: '32px',
  },
  checked: {
    color: '#027CB5',
  },
  selectAll: {
    marginLeft: '16px',
  },
  filterIcon: {
    padding: '12px',
  },
  success: {
    color: '#28a745',
  },
  error: {
    color: '#dc3545',
  },
  warn: {
    color: '#ffc107',
  },
};

export default withStyles(styles)(CustomSelect);
